import { VoidMarriage } from 'shell/models/person/void-marriage';
import { AccordionVoidMarriage } from 'shell/components/shared/sipo-person-form/new-person';

export const transformVoidMarriage = (
  values: AccordionVoidMarriage | undefined
): VoidMarriage | undefined => {
  const withMunicipalityRegistration = !!values?.municipality?.id || values?.location;

  const withSentenza =
    values?.authority ||
    values?.eventDate ||
    values?.validityDate ||
    values?.number ||
    values?.courtType;

  const withVoidMarriagecertificatePaper =
    withMunicipalityRegistration ||
    values?.office ||
    values?.year ||
    values?.portion ||
    values?.range ||
    values?.documentNumber ||
    values?.regVol ||
    values?.documentDate;

  const originReturnData: VoidMarriage | undefined = values
    ? {
        attoAnnullamentoMatrimonio: withVoidMarriagecertificatePaper
          ? {
              ufficioMunicipio: values?.office || undefined,
              anno: values?.year || undefined,
              parte: values?.portion || undefined,
              serie: values?.range || undefined,
              numeroAtto: values?.documentNumber || undefined,
              volume: values?.regVol || undefined,
              dataFormazioneAtto: values?.documentDate?.toFormat('yyyy-MM-dd') || undefined,
              trascritto: values?.transcript ? '1' : undefined,
              comuneRegistrazione: withMunicipalityRegistration
                ? {
                    nomeComune: values?.municipality?.description || undefined,
                    codiceIstat: values?.municipality?.id || undefined,
                    siglaProvinciaIstat: values?.municipality?.province || undefined,
                    descrizioneLocalita: values?.location || undefined,
                  }
                : undefined,
            }
          : undefined,
        sentenza: withSentenza
          ? {
              autorita: values?.authority || undefined,
              data: values?.eventDate?.toFormat('yyyy-MM-dd') || undefined,
              dataValidita: values?.validityDate?.toFormat('yyyy-MM-dd') || undefined,
              numero: values?.number?.toString() || undefined,
              tipoTribunale: values?.courtType || undefined,
            }
          : undefined,
        tipoCessazione: values?.type || undefined,
      }
    : undefined;

  return originReturnData;
};
